import { cn } from '../../lib/cn';
import type { MessageReaction } from '../../services/messaging/messageReactionService';

interface Props {
  reactions: MessageReaction[];
  currentCollaboratorId: string | null;
  onToggle: (emoji: string, hasReacted: boolean) => void;
  isOwn: boolean;
}

interface Grouped {
  emoji: string;
  count: number;
  hasMine: boolean;
  names: string[];
}

export function MessageReactionPills({ reactions, currentCollaboratorId, onToggle, isOwn }: Props) {
  if (reactions.length === 0) return null;

  const map = new Map<string, Grouped>();
  for (const r of reactions) {
    const g = map.get(r.emoji) ?? { emoji: r.emoji, count: 0, hasMine: false, names: [] };
    g.count += 1;
    if (r.collaborator_id === currentCollaboratorId) g.hasMine = true;
    if (r.collaborator?.full_name) g.names.push(r.collaborator.full_name);
    map.set(r.emoji, g);
  }
  const groups = Array.from(map.values());

  return (
    <div className={cn('flex flex-wrap gap-1 mt-1', isOwn ? 'justify-end' : 'justify-start')}>
      {groups.map((g) => (
        <button
          key={g.emoji}
          type="button"
          onClick={() => onToggle(g.emoji, g.hasMine)}
          className={cn(
            'flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs border transition-colors',
            g.hasMine
              ? 'bg-cime-primary/10 border-cime-primary/40 text-cime-text-primary hover:bg-cime-primary/15'
              : 'bg-cime-surface border-cime-border text-cime-text-primary hover:bg-cime-bg',
          )}
          title={g.names.join(', ')}
        >
          <span className="text-sm leading-none">{g.emoji}</span>
          <span className="font-medium">{g.count}</span>
        </button>
      ))}
    </div>
  );
}
